module.exports = __webpack_public_path__ + "static/media/JOBS.3bbf0306.mp4";